<div>
  <div class="card title-card">
    <div role="toolbar" class="flex">
      <div class="flex">
        <div>
          <i class="pi pi-briefcase title-card-icon"></i>
        </div>
        <div>
          <p class="mb-0 text-3xl title">{{'preview.list' | transloco}}</p>
          <p>{{'preview.description' | transloco}}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex flex-column md:flex-row">
            <button pButton pRipple label=" {{'common.new' | transloco}}" icon="pi pi-plus"
                    class="md:mr-2 p-button-primary mb-2 md:mb-0"></button>
            <button pButton pRipple label=" {{'common.delete' | transloco}}"
                    [disabled]="selectedPreviewItems.length == 0"
                    icon="pi pi-trash" class="p-button-danger mb-2 sm:mb-0"></button>
          </div>
          <div class="flex flex-column md:flex-row justify-content-end">
            <button pButton label=" {{'common.filters' | transloco}}" class="p-button-secondary" icon="pi pi-sliders-h"></button>
          </div>
        </div>
      </div>
      <p-table [value]="previewItems" [responsive]="true" sortField="identifier" class="p-datatable-responsive"
               styleClass="p-datatable-striped" [(selection)]="selectedPreviewItems" breakpoint="1200px">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th pSortableColumn="identifier">
              {{'preview.identifier' | transloco}}<p-sortIcon field="identifier"></p-sortIcon></th>
            <th pSortableColumn="description">
              {{'preview.description' | transloco}}<p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="status">
              {{'preview.status' | transloco}}<p-sortIcon field="status"></p-sortIcon></th>
            <th pSortableColumn="lastValue">
              {{'preview.lastValue' | transloco}}<p-sortIcon field="lastValue"></p-sortIcon></th>
            <th style="width: 10rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox [value]="row"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'preview.identifier' | transloco}}</span>
              <p class="bold cursor-pointer">{{row.identifier}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'preview.description' | transloco}}</span>
              <p class="text-right md:text-left">{{row.description}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'preview.status' | transloco}}</span>
              <p-tag *ngIf="row.status === 'online'" value="Online"></p-tag>
              <p-tag *ngIf="row.status === 'offline'" value="Offline" styleClass="tag-secondary"></p-tag>
            </td>
            <td>
              <span class="p-column-title bold">{{'preview.lastValue' | transloco}}</span>
              <p class="text-right md:text-left">{{row.lastValue | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div>
                <button class="p-button-rounded btn-primary-light mr-2" pButton pRipple icon="pi pi-pencil"></button>
                <button class="p-button-rounded btn-primary-light" pButton pRipple icon="pi pi-trash"></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
